export default "__VITE_ASSET__DSP$2OZN__"